/**
 * @typedef {import('../Component').FilterValue} Value
 */
import FieldRadio from '../../../../../shared/Forms/Fields/FieldRadio';
import React from 'react';
import ToggleList from './ToggleList';

/**
 * @extends {ToggleList}
 */
export default class RadioList extends ToggleList {
	_className = 'radio';

	/**
	 * @protected
	 * @param {string} name
	 * @param {string} label
	 * @param {Value} value
	 * @returns {React.ReactNode}
	 */
	_renderInput(name, label, value) {
		const inputName = this._inputName(name);
		const id = this._inputId(name, label);

		return (
			<FieldRadio
				className="my-2"
				id={id}
				key={name + label}
				label={label}
				name={inputName}
				onChange={this._handleChange}
				required={false}
				value={`${value}`}
			/>
		);
	}
}
